<template>
  <v-layout align-center justify-center row fill-height>
    <v-flex xs12 sm12 md10 lg8>
      <MessageBox
        id="msgJustificante"
        :title="$t('message.comun.justificante.titulo')"
        type="success"
      >
        <p
          v-if="cdregist != null && cdregist != 'PENDIENTE_REGISTRO'"
          class="textoImportante"
          v-html="
            $t('message.comun.justificante.texto', { cdregist: cdregist, nujustas: nujustas })
          "
        ></p>
        <p
          v-if="cdregist != null && cdregist == 'PENDIENTE_REGISTRO'"
          class="textoImportante"
          v-html="
            $t('message.comun.justificante.enProceso', { cdregist: cdregist, nujustas: nujustas })
          "
        ></p>
        <template slot="texto">
          <v-list two-line>
            <v-divider inset></v-divider>
            <div
              v-if="cdregist != null && cdregist != 'PENDIENTE_REGISTRO'"
              v-for="item in items"
              :key="item.title"
            >
              <v-list-tile @click="getDocument(item.metodo)">
                <v-list-tile-action>
                  <v-icon :color="item.color">{{ item.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon>{{ item.iconDescarga }}</v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider inset></v-divider>
            </div>
          </v-list>
        </template>
      </MessageBox>
    </v-flex>
  </v-layout>
</template>
<script>
import { MessageBox } from '@/components';
import { getJustificante, getCartaDePago } from '@/api/declaraciones';
import logger from '@/utils/logger';

export default {
  name: 'justificante',
  props: {
    cdregist: {
      type: String,
      required: true
    },
    nujustas: {
      type: String,
      required: true
    }
  },
  components: {
    MessageBox
  },
  data() {
    return {
      items: [
        {
          icon: 'how_to_reg',
          color: 'success',
          title: this.$t('message.comun.justificante.tooltipRegistro'),
          iconDescarga: 'get_app',
          metodo: 'justificante'
        },
        {
          icon: 'description',
          color: 'info',
          title: this.$t('message.comun.justificante.tooltipNumero'),
          iconDescarga: 'get_app',
          metodo: 'cartaDepago'
        }
      ]
    };
  },
  methods: {
    getDocument(documento) {
      if (documento === 'justificante') {
        return this.getJustificanteHandler(this.cdregist);
      } else {
        return this.getCartaDePagoHandler(this.cdregist);
      }
    },
    getCartaDePagoHandler(cdregist) {
      getCartaDePago(cdregist)
        .then(response => {
          var bData = new Blob([response.data], {
            type: 'application/pdf'
          });
          var nombre = this.nujustas + '.pdf';
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(bData, nombre);
          } else {
            const url = window.URL.createObjectURL(bData);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nombre);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(error => {
          logger.print(error);
        });
    },
    getJustificanteHandler(cdregist) {
      getJustificante(cdregist)
        .then(response => {
          // Info del fichero
          var bData = new Blob([response.data], {
            type: 'application/pdf'
          });
          var nombre = cdregist + '.pdf';
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveOrOpenBlob(bData, nombre);
          } else {
            const url = window.URL.createObjectURL(bData);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nombre);
            document.body.appendChild(link);
            link.click();
          }
        })
        .catch(error => {
          logger.print(error);
        });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
.justificante {
  width: 60% !important;
  align-content: center;
}

.textoImportante {
  font-size: 18px;
}
</style>
